import { HttpStatusCode } from './constant';
import { buildURL, buildFetchInit, parseResponseData } from './util';
/**
 * @param {RequestOptions} param 接收参数
 * @param {string} [param.path] 请求地址
 * @param {boolean} [autoTip=true] 是否自动提示
 * @return {Promise}
 */

/**
 * 执行请求
 * @param {RequestOptions} param 请求参数
 * @return {Promise<any>} 请求结果
 */
export function doRequest(param: RequestOptions): Promise<any> {
  if (param.useMock) {
    return Promise.resolve({
      code: HttpStatusCode.Success,
      data: param.mockData
    });
  }

  const url = buildURL(param);
  const fetchInit = buildFetchInit(param);

  return window
    .fetch(url, fetchInit)
    .then(function (res) {
      return parseResponseData(res, res.headers.get('Content-Type')).then(
        function (respBody) {
          const httpCode: any =
            respBody && respBody.status
              ? respBody.status
              : res && res.status
              ? res.status
              : null;

          if (httpCode < 200 || httpCode >= 300) {
            return {
              code: String(httpCode),
              message: '网络错误'
            };
          } else {
            // 从响应头读取 Date 字段（服务器当前时间）
            const dateHeader = res.headers ? res.headers.get('Date') : '';
            // 构造额外的参数
            const options = {
              code: HttpStatusCode.Success,
              serverTimeFromHeader: dateHeader
            };
            // 组合数据
            return Object.assign(options, respBody);
          }
        }
      );
    })
    .catch(function () {
      // 捕获所有错误，返回登录过期
      return {
        code: 401,
        message: '网络异常'
      };
    });
}

const defaultRequestOption: RequestOptions = {
  method: 'GET',
  contentType: 'application/json',
  timeout: 15000
};

/**
 * 创建一个超时Promise
 * @param {number} timeout 超时时间（毫秒）
 * @return {Promise<any>} 超时Promise
 */
function makeTimeoutPromise(timeout: number): Promise<any> {
  return new Promise(function (resolve: any) {
    setTimeout(function () {
      resolve({
        code: '3001',
        message: '请求超时',
        requestId: '',
        eventType: '',
        traceId: ''
      });
    }, timeout);
  });
}

/**
 * 发送请求
 * @param {RequestOptions} opts 请求参数
 * @return {Promise<any>} 请求结果
 */
export function request(opts: RequestOptions): Promise<any> {
  const options = Object.assign({}, defaultRequestOption, opts);
  return Promise.race([
    makeTimeoutPromise(options.timeout!),
    doRequest(options)
  ]);
}
